<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
export default {
  onLaunch: function () {
    if (!uni.getStorageSync("token")) {
      uni.hideTabBar();
      uni.reLaunch({
        url: "/page-init/init/index",
      });
    }
  },
  onShow: function () {},
  onHide: function () {
    console.log("App Hide");
  },
};
</script>

<style lang="scss">
// 字体图标
@import "@/styles/fonts.scss";
@import "static/iconfont/index.wxss";
// 引入uView基础样式
@import "uview-ui/index.scss";
</style>